import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enUS from './locales/en-US.json'
import deDE from './locales/de-DE.json'

const resources = {
    'en-US': {
        translation: enUS,
    },
    'de-DE': {
        translation: deDE,
    },
}

// Get saved language from localStorage or default to browser language
const getInitialLanguage = (): string => {
    const savedLanguage = localStorage.getItem('i18nextLng')
    if (savedLanguage && (savedLanguage === 'en-US' || savedLanguage === 'de-DE')) {
        return savedLanguage
    }
    
    // Try to detect browser language
    const browserLang = navigator.language || 'en-US'
    if (browserLang.startsWith('de')) {
        return 'de-DE'
    }
    
    return 'en-US'
}

i18n.use(initReactI18next).init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en-US',
    interpolation: {
        escapeValue: false, // React already escapes values
    },
    react: {
        useSuspense: false,
    },
})

export default i18n

